import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modeInput", "rangeFields", "activeFields", "minAmountInput", "maxAmountInput", "isActiveInput"];

  declare readonly modeInputTargets: HTMLInputElement[];
  declare readonly rangeFieldsTarget: HTMLElement;
  declare readonly activeFieldsTarget: HTMLElement;
  declare readonly hasMinAmountInputTarget: boolean;
  declare readonly hasMaxAmountInputTarget: boolean;
  declare readonly hasIsActiveInputTarget: boolean;
  declare readonly isActiveInputTarget: HTMLInputElement;

  connect(): void {
    this.onModeChange();
  }

  onModeChange(): void {
    const selected = this.modeInputTargets.find((input) => input.checked)?.value;
    const previous = this.element.dataset.previousMode;

    if (selected === "WITHIN_RANGE") {
      this.rangeFieldsTarget.classList.remove("hidden");
    } else {
      this.rangeFieldsTarget.classList.add("hidden");
    }

    if (selected === "DISABLED") {
      this.activeFieldsTarget.classList.add("hidden");
      if (this.hasIsActiveInputTarget) {
        this.isActiveInputTarget.checked = false;
      }
    } else {
      this.activeFieldsTarget.classList.remove("hidden");
      if (this.hasIsActiveInputTarget && previous === "DISABLED") {
        this.isActiveInputTarget.checked = true;
      }
    }

    if (selected) {
      this.element.dataset.previousMode = selected;
    }
  }
}
